import React from "react";
import bg_img_1 from "../../assets/images/bg-img-home-sec.png";
import bg_img_2 from "../../assets/images/home-sec-img-bg-1.png";
import icon_img_1 from "../../assets/images/Professional-Doctors-img.png";
import icon_img_2 from "../../assets/images/Globally-Hospitals-img.png";
import icon_img_3 from "../../assets/images/Years-of-Expereince-img.png";
import icon_img_4 from "../../assets/images/Successful-Operations.png";
import CountUp from "react-countup";
import { useInView } from "react-intersection-observer";
const HomePageTotals = () => {
  const { ref, inView } = useInView({ triggerOnce: true, threshold: 0.4 });

  return (
    <div
      className="w-full xl:pt-44 xl:pb-20 pt-20 pb-16 flex justify-center flex-row items-center relative"
      style={{
        backgroundImage: `url(${bg_img_1})`,
        backgroundSize: "cover",
        backgroundPosition: "center",
        backgroundColor: "#0F2349",
      }}
    >
      {/* Overlay */}
      <div
        className="absolute inset-0 xl:block hidden z-20"
        style={{
          backgroundImage: `url(${bg_img_2})`,
          backgroundSize: "cover",
          backgroundPosition: "center",
        }}
      ></div>
      <div className="2xl:w-3/5 xl:w-4/5 w-full flex flex-col md:flex-row justify-center items-center gap-10 md:gap-8 px-4 md:px-0">
        <div className="flex flex-col md:w-1/4 w-full justify-center md:justify-start items-center md:items-start gap-0 md:border-r md:pr-8 px-4 lg:px-6 xl:px-8">
          <div className="mb-4">
            <img width="54" height="73" src={icon_img_1} alt="icon_img_1" />
          </div>
          <h3
            ref={ref}
            className="text-5xl md:text-3xl lg:text-[52px] my-4 font-semibold text-white font-outfit"
          >
            {inView ? <CountUp end={3821} duration={2} separator="" /> : null}+
          </h3>
          <p className="text-[#A2B1CC] text-lg font-semibold font-outfit text-center md:text-left">
            Professional Doctors
          </p>
        </div>

        <div className="flex flex-col md:w-1/4 w-full justify-center md:justify-start items-center md:items-start gap-0 md:border-r md:pr-8 px-4 md:px-0">
          <div className="mb-4">
            <img width="70" height="73" src={icon_img_2} alt="icon_img_2" />
          </div>
          <h3
            ref={ref}
            className="text-5xl md:text-3xl lg:text-[52px] my-4 font-semibold text-white font-outfit"
          >
            {inView ? <CountUp end={8596} duration={2} separator="" /> : null}
          </h3>
          <p className="text-[#A2B1CC] text-lg font-semibold font-outfit text-center md:text-left">
            Globally Hospitals
          </p>
        </div>

        <div className="flex flex-col md:w-1/4 w-full justify-center md:justify-start items-center md:items-start gap-0 md:border-r md:pr-8 px-4 md:px-0">
          <div className="mb-4">
            <img width="72" height="73" src={icon_img_3} alt="icon_img_3" />
          </div>
          <h3
            ref={ref}
            className="text-5xl md:text-3xl lg:text-[52px] my-4 font-semibold text-white font-outfit"
          >
            {inView ? <CountUp end={10} duration={2} separator="" /> : null}+
          </h3>
          <p className="text-[#A2B1CC] text-lg font-semibold font-outfit text-center md:text-left">
            Years of Experience
          </p>
        </div>

        <div className="flex flex-col md:w-1/4 w-full justify-center md:justify-start items-center md:items-start gap-0 px-4 md:px-0">
          <div className="mb-4">
            <img width="73" height="52" src={icon_img_4} alt="icon_img_4" />
          </div>
          <h3
            ref={ref}
            className="text-5xl md:text-3xl lg:text-[52px] my-4 font-semibold text-white font-outfit"
          >
            {inView ? <CountUp end={100} duration={2} separator="" /> : null}+
          </h3>
          <p className="text-[#A2B1CC] text-lg font-semibold font-outfit text-center md:text-left">
            Successful Operations
          </p>
        </div>
      </div>
    </div>
  );
};

export default HomePageTotals;
